// Community Shift Management APIs

/**
 * @function ApiClient#GetShiftList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} month
 * @param {any} name
 * @param {any} department
 * @param {any} options = {}
 */
export async function GetShiftList(cid, month, name, department, options = {}) {
  if (!name) name = "";
  if (!department) department = "";
  return await this._get(`/community/${cid}/shift_list?m=${month}&n=${name}&d=${department}`, options);
}

/**
 * @function ApiClient#UpdateShift
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} shift
 * @param {any} options = {}
 */
export async function UpdateShift(cid, shift, options = {}) {
  return await this._put(`/community/${cid}/shift`, shift, options);
}

/**
 * @function ApiClient#UpdateShiftBatch
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} month
 * @param {any} users
 * @param {any} weeks
 * @param {any} shift
 * @param {any} options = {}
 */
export async function UpdateShiftBatch(cid, month, users, weeks, shift, options = {}) {
  const formData = new FormData();
  formData.set("s", JSON.stringify(shift));
  return await this._put(`/community/${cid}/shift_batch?m=${month}&u=${users}&w=${weeks}`, formData, options);
}

/**
 * @function ApiClient#DeleteShift
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} uid
 * @param {any} year
 * @param {any} month
 * @param {any} day
 * @param {any} options = {}
 */
export async function DeleteShift(cid, uid, year, month, day, options = {}) {
  return await this._delete(`/community/${cid}/shift?u=${uid}&d=${year}-${month}-${day}`, options);
}

/**
 * @function ApiClient#DeleteShiftBatch
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} month
 * @param {any} users
 * @param {any} options = {}
 */
export async function DeleteShiftBatch(cid, month, users, options = {}) {
  return await this._delete(`/community/${cid}/shift_batch?m=${month}&u=${users}`, options);
}

// Shift Type Management APIs

/**
 * @function ApiClient#GetShiftTypeList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetShiftTypeList(cid, options = {}) {
  return await this._get(`/community/${cid}/shift_type_list`, options);
}

/**
 * @function ApiClient#UpdateShiftType
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} types
 * @param {any} options = {}
 */
export async function UpdateShiftType(cid, types, options = {}) {
  return await this._put(`/community/${cid}/shift_type`, types, options);
}

// Shift Check Code APIs

/**
 * @function ApiClient#GetShiftCheckCode
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetShiftCheckCode(cid, options = {}) {
  return await this._get(`/community/${cid}/shift_check_code`, options);
}
